
import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    error: null
}

// Participant/ParticipantBiometric/Create	POST	Service at http://demo.staging.iv.wellsuite.com/WsWebServicePlatform/Participant/ParticipantBiometric/Create

// Participant/ParticipantBiometric/Create/{AuthToken}/{ParticipantGuid}/{ParticipantBiometricTypeGuid}/{StartDate}/{EndDate}/{BioAge}
//{BioClinSystolicBP}/{BioClinDiastolicBP}/{BioClinHdlCholesterol}/{BioClinTotalCholesterol}/{BioClinLDLCholesterol}
//{BioClinTriglycerides}/{BioClinRestingPulse}/{BioClinBloodGlucose}/{BioClinWeight}/{BioClinHeightInches}/{BioClinGXTMinutes}
//{BioClinGXTSeconds}/{BioClinGXTHeartRate}/{BioClinPercentFat}/{BioClinWaistCirc}/{BioClinA1c}/{BioClinKnownMets}/{BioClinNonFastBloodTest}
//{BioClinCurlups}/{BioClinFlexibility}/{BioClinGripStrength}/{BioClinPushups}/{BioClinPSA}/{LanguageID}/	POST	Service at http://demo.staging.iv.wellsuite.com/WsWebServicePlatform/Participant/ParticipantBiometric/Create/{AUTHTOKEN}/{PARTICIPANTGUID}/{BIOMETRICTYPEGUID}/{STARTDATE}/{ENDDATE}/{BIOAGE}/{BIOCLINSYSTOLICBP}/{BIOCLINDIASTOLICBP}/{BIOCLINHDLCHOLESTEROL}/{BIOCLINTOTALCHOLESTEROL}/{BIOCLINLDLCHOLESTEROL}/{BIOCLINTRIGLYCERIDES}/{BIOCLINRESTINGPULSE}/{BIOCLINBLOODGLUCOSE}/{BIOCLINWEIGHT}/{BIOCLINHEIGHTINCHES}/{BIOCLINGXTMINUTES}/{BIOCLINGXTSECONDS}/{BIOCLINGXTHEARTRATE}/{BIOCLINPERCENTFAT}/{BIOCLINWAISTCIRC}/{BIOCLINA1C}/{BIOCLINKNOWNMETS}/{BIOCLINNONFASTBLOODTEST}/{BIOCLINCURLUPS}/{BIOCLINFLEXIBILITY}/{BIOCLINGRIPSTRENGTH}/{BIOCLINPUSHUPS}/{BIOCLINPSA}/{LANGUAGEID}/

// Participant/ParticipantBiometric/Create/{AuthToken}/{ParticipantGuid}/{ParticipantBiometricTypeGuid}/{StartDate}/{EndDate}/{BioAge}
//{BioClinSystolicBP}/{BioClinDiastolicBP}/{BioClinHdlCholesterol}/{BioClinTotalCholesterol}/{BioClinLDLCholesterol}
//{BioClinTriglycerides}/{BioClinRestingPulse}/{BioClinBloodGlucose}/{BioClinWeight}/{BioClinHeightInches}/{BioClinGXTMinutes}
//{BioClinGXTSeconds}/{BioClinGXTHeartRate}/{BioClinPercentFat}/{BioClinWaistCirc}/{BioClinA1c}/{BioClinKnownMets}/{BioClinNonFastBloodTest}
//{BioClinCurlups}/{BioClinFlexibility}/{BioClinGripStrength}/{BioClinPushups}/{BioClinPSA}/{LanguageID}/{ParticipantBiometricCollectDate}/	POST	Service at http://demo.staging.iv.wellsuite.com/WsWebServicePlatform/Participant/ParticipantBiometric/Create/{AUTHTOKEN}/{PARTICIPANTGUID}/{BIOMETRICTYPEGUID}/{STARTDATE}/{ENDDATE}/{BIOAGE}/{BIOCLINSYSTOLICBP}/{BIOCLINDIASTOLICBP}/{BIOCLINHDLCHOLESTEROL}/{BIOCLINTOTALCHOLESTEROL}/{BIOCLINLDLCHOLESTEROL}/{BIOCLINTRIGLYCERIDES}/{BIOCLINRESTINGPULSE}/{BIOCLINBLOODGLUCOSE}/{BIOCLINWEIGHT}/{BIOCLINHEIGHTINCHES}/{BIOCLINGXTMINUTES}/{BIOCLINGXTSECONDS}/{BIOCLINGXTHEARTRATE}/{BIOCLINPERCENTFAT}/{BIOCLINWAISTCIRC}/{BIOCLINA1C}/{BIOCLINKNOWNMETS}/{BIOCLINNONFASTBLOODTEST}/{BIOCLINCURLUPS}/{BIOCLINFLEXIBILITY}/{BIOCLINGRIPSTRENGTH}/{BIOCLINPUSHUPS}/{BIOCLINPSA}/{LANGUAGEID}/{BIOMETRICCOLLECTDATE}/

// Participant/ParticipantBiometric/Delete/{AuthToken}/{ParticipantBiometricGuid}/	POST	Service at http://demo.staging.iv.wellsuite.com/WsWebServicePlatform/Participant/ParticipantBiometric/Delete/{AUTHTOKEN}/{BIOMETRICGUID}/
// Participant/ParticipantBiometric/Types/Get/{AuthToken}/	GET	Service at http://demo.staging.iv.wellsuite.com/WsWebServicePlatform/Participant/ParticipantBiometric/Types/Get/{AUTHTOKEN}/
// Participant/ParticipantBiometric/Update	POST	Service at http://demo.staging.iv.wellsuite.com/WsWebServicePlatform/Participant/ParticipantBiometric/Update
// Participant/ParticipantBiometric/Update/{AuthToken}/{ParticipantBiometricGuid}/{ParticipantBiometricTypeGuid}/{StartDate}/{EndDate}/{BioAge}/{BioClinSystolicBP}/{BioClinDiastolicBP}/{BioClinHdlCholesterol}/{BioClinTotalCholesterol}/{BioClinLDLCholesterol}/{BioClinTriglycerides}/{BioClinRestingPulse}/{BioClinBloodGlucose}/{BioClinWeight}/{BioClinHeightInches}/{BioClinGXTMinutes}/{BioClinGXTSeconds}/{BioClinGXTHeartRate}/{BioClinPercentFat}/{BioClinWaistCirc}/{BioClinA1c}/{BioClinKnownMets}/{BioClinNonFastBloodTest}/{BioClinCurlups}/{BioClinFlexibility}/{BioClinGripStrength}/{BioClinPushups}/{BioClinPSA}/	POST	Service at http://demo.staging.iv.wellsuite.com/WsWebServicePlatform/Participant/ParticipantBiometric/Update/{AUTHTOKEN}/{BIOMETRICGUID}/{BIOMETRICTYPEGUID}/{STARTDATE}/{ENDDATE}/{BIOAGE}/{BIOCLINSYSTOLICBP}/{BIOCLINDIASTOLICBP}/{BIOCLINHDLCHOLESTEROL}/{BIOCLINTOTALCHOLESTEROL}/{BIOCLINLDLCHOLESTEROL}/{BIOCLINTRIGLYCERIDES}/{BIOCLINRESTINGPULSE}/{BIOCLINBLOODGLUCOSE}/{BIOCLINWEIGHT}/{BIOCLINHEIGHTINCHES}/{BIOCLINGXTMINUTES}/{BIOCLINGXTSECONDS}/{BIOCLINGXTHEARTRATE}/{BIOCLINPERCENTFAT}/{BIOCLINWAISTCIRC}/{BIOCLINA1C}/{BIOCLINKNOWNMETS}/{BIOCLINNONFASTBLOODTEST}/{BIOCLINCURLUPS}/{BIOCLINFLEXIBILITY}/{BIOCLINGRIPSTRENGTH}/{BIOCLINPUSHUPS}/{BIOCLINPSA}/
// Participant/ParticipantBiometric/Update/{AuthToken}/{ParticipantBiometricGuid}/{ParticipantBiometricTypeGuid}/{StartDate}/{EndDate}/{BioAge}/{BioClinSystolicBP}/{BioClinDiastolicBP}/{BioClinHdlCholesterol}/{BioClinTotalCholesterol}/{BioClinLDLCholesterol}/{BioClinTriglycerides}/{BioClinRestingPulse}/{BioClinBloodGlucose}/{BioClinWeight}/{BioClinHeightInches}/{BioClinGXTMinutes}/{BioClinGXTSeconds}/{BioClinGXTHeartRate}/{BioClinPercentFat}/{BioClinWaistCirc}/{BioClinA1c}/{BioClinKnownMets}/{BioClinNonFastBloodTest}/{BioClinCurlups}/{BioClinFlexibility}/{BioClinGripStrength}/{BioClinPushups}/{BioClinPSA}/{ParticipantBiometricCollectDate}/	POST	Service at http://demo.staging.iv.wellsuite.com/WsWebServicePlatform/Participant/ParticipantBiometric/Update/{AUTHTOKEN}/{BIOMETRICGUID}/{BIOMETRICTYPEGUID}/{STARTDATE}/{ENDDATE}/{BIOAGE}/{BIOCLINSYSTOLICBP}/{BIOCLINDIASTOLICBP}/{BIOCLINHDLCHOLESTEROL}/{BIOCLINTOTALCHOLESTEROL}/{BIOCLINLDLCHOLESTEROL}/{BIOCLINTRIGLYCERIDES}/{BIOCLINRESTINGPULSE}/{BIOCLINBLOODGLUCOSE}/{BIOCLINWEIGHT}/{BIOCLINHEIGHTINCHES}/{BIOCLINGXTMINUTES}/{BIOCLINGXTSECONDS}/{BIOCLINGXTHEARTRATE}/{BIOCLINPERCENTFAT}/{BIOCLINWAISTCIRC}/{BIOCLINA1C}/{BIOCLINKNOWNMETS}/{BIOCLINNONFASTBLOODTEST}/{BIOCLINCURLUPS}/{BIOCLINFLEXIBILITY}/{BIOCLINGRIPSTRENGTH}/{BIOCLINPUSHUPS}/{BIOCLINPSA}/{BIOMETRICCOLLECTDATE}/
// Participant/ParticipantBiometrics/Get/{AuthToken}/{ParticipantGuid}/


const PLATFORM = '../../WsWebServicePlatform/'

export const fetchParticipantBiometrics = createAsyncThunk('participantBiometric/get', async (incomingVariable, thunkAPI) => {

    try {
        const response = await axios.get(PLATFORM + "Participant/Biometrics/Get/" + incomingVariable.authToken + "/" + incomingVariable.ParticipantGuid + "/")
        const data = await response.data

        return data
    } catch (err) {

        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

export const createParticipantBiometrics = createAsyncThunk('participantBiometric/create', async (incomingVariable, thunkAPI) => {

    try {
        const response = await axios.post(PLATFORM
            + "Participant/Biometric/Create/"
            + incomingVariable.authToken + "/"
            + incomingVariable.ParticipantGuid + "/"
            + incomingVariable.ParticipantBiometricTypeGuid + "/"
            + incomingVariable.Priority + "/"
            + incomingVariable.ParticipantBiometric1 + "/"
            + incomingVariable.ParticipantBiometric2 + "/"
            + incomingVariable.ParticipantBiometric3 + "/"
            + incomingVariable.City + "/"
            + incomingVariable.StateProvinceCounty + "/"
            + incomingVariable.PostalCode + "/"
            + incomingVariable.CountryCode + "/"
        )
        const data = await response.data.Success ? response.data : [response.data]

        return data
    } catch (err) {

        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

export const updateParticipantBiometrics = createAsyncThunk('participantBiometric/update', async (incomingVariable, thunkAPI) => {

    try {
        const response = await axios.post(PLATFORM
            + "Participant/Biometric/Update/"
            + incomingVariable.authToken + "/"
            + incomingVariable.ParticipantBiometricGuid + "/"
            + incomingVariable.ParticipantBiometricTypeGuid + "/"
            + incomingVariable.Priority + "/"
            + incomingVariable.ParticipantBiometric1 + "/"
            + incomingVariable.ParticipantBiometric2 + "/"
            + incomingVariable.ParticipantBiometric3 + "/"
            + incomingVariable.City + "/"
            + incomingVariable.StateProvinceCounty + "/"
            + incomingVariable.PostalCode + "/"
            + incomingVariable.CountryCode + "/"
        )
        const data = await response.data.Success ? response.data : [response.data]

        return data
    } catch (err) {

        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

const participantBiometricSlice = createSlice({
    name: 'participantBiometrics',
    initialState,
    reducers: {
        participantBiometricClear(state, action) {
            state.entities = initialState.entities
            state.status = "idle"
        }
        , participantBiometricUpdate(state, action) {
            const data = action.payload
            state.entities[data.BiometricGuid] = data
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchParticipantBiometrics.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchParticipantBiometrics.fulfilled, (state, action) => {
                const Success = action.payload.Success
                if (Success === true) {

                    const loadedData = action.payload.Info
                    state.status = 'success'

                    const data = {}
                    for (var i = 0; i < loadedData.length; i++) {
                        const partObject = loadedData[i]
                        data[partObject.BiometricGuid] = partObject
                    }
                    state.entities = data
                } else {
                    state.error = action.payload.Status[0]
                    state.status = "failed"

                }
            })
            .addCase(fetchParticipantBiometrics.rejected, (state, action) => {
                state.error = action.error.message

            })
            .addCase(updateParticipantBiometrics.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(updateParticipantBiometrics.fulfilled, (state, action) => {
                const Success = action.payload.Success
                if (Success === true) {

                    state.status = 'success'
                    const loadedData = action.payload.Info
                    for (var i = 0; i < loadedData.length; i++) {
                        const partObject = loadedData[i]
                        state.entities[partObject.BiometricGuid] = partObject
                    }
                } else {
                    state.error = action.payload.Status[0]
                    state.status = "failed"

                }
            })
            .addCase(updateParticipantBiometrics.rejected, (state, action) => {
                state.error = action.error.message
                state.status = "failed"
            })
            .addCase(createParticipantBiometrics.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(createParticipantBiometrics.fulfilled, (state, action) => {
                const Success = action.payload.Success
                if (Success === true) {

                    state.status = 'success'
                    const loadedData = action.payload.Info
                    for (var i = 0; i < loadedData.length; i++) {
                        const partObject = loadedData[i]
                        state.entities[partObject.BiometricGuid] = partObject
                    }
                } else {
                    state.error = action.payload.Status[0]
                    state.status = "failed"

                }
            })
            .addCase(createParticipantBiometrics.rejected, (state, action) => {
                state.error = action.error.message
                state.status = "failed"
            })
    }
})

export const { participantBiometricClear } = participantBiometricSlice.actions

export default participantBiometricSlice.reducer

const selectParticipantBiometricsEntities = (state) => state.participantBiometrics.entities

export const selectParticipantBiometrics = createSelector(selectParticipantBiometricsEntities, (entities) =>
    Object.values(entities)
)

export const selectParticipantBiometricsById = (state, ParticipantBiometricsId) => {
    return selectParticipantBiometricsEntities(state)[ParticipantBiometricsId]
}

export const selectParticipantBiometricsByTypeGuid = createSelector(
    selectParticipantBiometrics
    , (state, ParticipantBiometricTypeId_Guid) => ParticipantBiometricTypeId_Guid
    , (addresses, guid) => {

        return addresses.filter(address => {
            return address.ParticipantBiometricTypeGuid && address.ParticipantBiometricTypeGuid === guid
        })
    }

)